export default __webpack_public_path__ + "static/media/vip-icon.191678b4.webp";